import { useAppContext } from 'hooks/useAppContext';
import { useFilteredData } from 'hooks/useFilteredData';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';

export const useSelectAllTruckers = () => {
  const {
    state: {
      truckers: { meta },
    },
    dispatch,
  } = useAppContext();
  const { filteredDataSuggested } = useFilteredData();
  const { hasConsumed } = usePayPerUseExtraTruckers();

  const selectAllTruckers = () => {
    const dataWithoutLockedDrivers = [...filteredDataSuggested];

    if (meta?.truckersLimitsTotal?.locked && meta?.truckersLimitsTotal?.locked > 0 && !hasConsumed) {
      dataWithoutLockedDrivers?.splice(meta?.truckersLimitsTotal?.unlocked, dataWithoutLockedDrivers?.length);
    }

    const truckersListUuid = dataWithoutLockedDrivers?.map((trucker) => ({
      uuid: trucker.person.uuid,
      isShared: !!trucker.person.alreadyNotified,
    }));
    dispatch({ type: 'set_all_selected_truckers', payload: truckersListUuid });
  };

  const unselectAllTruckers = () => dispatch({ type: 'remove_all_selected_truckers' });

  return { selectAllTruckers, unselectAllTruckers };
};
